import { Button, Checkbox, ComboBox, IColumn, IComboBoxOption, Icon } from "@fluentui/react";
import MessageCourier from "../../lib/MessageCourier";
import TimeTaxSupportSystemClient from "../../system";
import { User } from "../../system/User";
import { DetailsListView } from "../Common/DetailsList/DetailListView";
import i18next, { t } from 'i18next';
import React, { useEffect, useState } from "react";
import { ListColumnFilter } from "../Common/list-entities/ListColumnFilter";
import { GRID_MODE, OPERATORS, TYPES } from "../../common/list-utils";
import _ from "lodash";
import { DateCustom } from "../../lib/DateCustom";
import { SaleDetailView } from "./SaleDetailView";

interface ISaleList {
  system?: TimeTaxSupportSystemClient;
  changeBlockUI: (state: boolean) => void;
  courier: MessageCourier;
  user?:User;
  refresh?: boolean;
  setItems?: React.Dispatch<React.SetStateAction<any[]>>;
}

export interface ISaleCompanyJson {
  empven_id?: string;
  empven_no_distribuir: boolean;
  empven_emp_id: string;
  empven_periodo: string;
  empven_valor_venta: string;
  empven_owner_colid: string;
  empven_fecha_actualizacion: string;
  empven_fecha_registro: string;
  empven_monedaid: number;
}

export const SaleView = (props: ISaleList) => {

    const [toastExit,setToastExit] = useState<boolean>(false);
    const [viewCreate,setViewCreate] = useState<React.SetStateAction<number>>(0);
    const [listCompanies, setListCompanies] = useState<IComboBoxOption[]>([]);
    const [listComaniesComplete, setListComaniesComplete] = useState<any[]>([]);
    const [refresh, setRefresh] = useState(false);

    const columns = [
      {
        key: "empven_no_distribuir",
        fieldName: "empven_no_distribuir",
        name: t("No distribuir"),
        minWidth: 100,
        maxWidth: 100,
         _onRender(item) {
          return (
            <Checkbox
              checked={item.empven_no_distribuir}
              onChange={() => handleUpdateDistribuicion(item)}
            />
          )
         }
      },
      {
        key: "emp_nombre",
        fieldName: "emp_nombre",
        name: t("Empresa"),
        minWidth: 200,
        maxWidth: 200
      },
      {
        key: "empven_periodo",
        fieldName: "empven_periodo",
        name: t("Periodo"),
        minWidth: 200,
        maxWidth: 200,
      },
      {
        key: "empven_fecha_carga",
        fieldName: "empven_fecha_actualizacion",
        name: t("Fecha de actualización"),
        minWidth: 200,
        maxWidth: 200,
      },
      {
        key: "moneda",
        fieldName: "moneda",
        name: t("Moneda"),
        minWidth: 100,
        maxWidth: 100
      },
      {
        key: "empven_valor_venta",
        fieldName: "empven_valor_venta",
        name: t("Valor de venta"),
        _onRender(item) {
          const value = Number(item.empven_valor_venta ?? 0);
          return `${statusCoin(item.moneda)} ${formatNumber(value)}`;
        },

        minWidth: 200,
        maxWidth: 200,
      },
    ];

    const statusCoin = (type) => {
      return type == "Sol" ? "S/. " : "$ ";
    }

    const listLevelsFilters: ListColumnFilter[] = [
      {
        quick: true,
        name: "empven_no_distribuir",
        type: TYPES.CHECKBOX,
        labelForCheckbox: t("No distribuir"),
        operator: OPERATORS.CONTAINS,
      },
      {
        quick: true,
        name: "emp_nombre",
        type: TYPES.COMBOBOX,
        placeholder: t("Empresa"),
        operator: OPERATORS.EQUAL,
        contextForCombobox: listCompanies,
      },
      {
        quick: true,
        name: "empven_periodo",
        type: TYPES.TYPE_DATE_YEAR_MONTH,
        placeholder: t("Periodo"),
        operator: OPERATORS.YEAR_MONTH_STRING,
        calendarProps: { isDayPickerVisible: false },
        isMonthSelector: true,
        formatDate: DateCustom.formatDateMMYYYY,
      },
    ];

    const baseUrl = React.useMemo(() => {
      setRefresh(false);
      return props.system?.getCompanySystem().getListEmpresaVentasDriverForDatagrid() ?? "";
    }, [props]);

    const handleListCompanies = async () => {
      const listCompanies = await props.system?.getCompanySystem().getList();

      const listCompanniesActives = listCompanies?.filter((item) => item.getActive())

      const listFilterCompanies = listCompanniesActives?.map((item) => ({
        key: item.getName(),
        text: item.getName(),
      }));

      setListComaniesComplete(listCompanniesActives || []);
      setListCompanies(listFilterCompanies || []);
    }

    const formatNumber = (value: number): string => {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    };

    const handleUpdateDistribuicion = async (item) => {
      try {
        const updatedItem: ISaleCompanyJson = {
          empven_id: item.empven_id,
          empven_no_distribuir: !item.empven_no_distribuir,
          empven_emp_id: item.empven_emp_id,
          empven_periodo: item.empven_periodo,
          empven_valor_venta: item.empven_valor_venta,
          empven_owner_colid: props.user?.getCollaboratorId() || "",
          empven_fecha_actualizacion: new Date().toISOString(),
          empven_fecha_registro: item.empven_fecha_registro ,
          empven_monedaid: item.empven_monedaid,
        };
        await props.system?.getCompanySystem().updateDistributionSaleCompany(updatedItem);
      } catch (error) {
        props.courier.messageError(error);
      } finally {
        setRefresh(true);
      }
    }

    useEffect(() => {
      handleListCompanies()
    }, []);

    return (
      <>
        {viewCreate === 0 ? (
          <div>
            {toastExit && (
              <div className="toast_container_collaborator">
                <div className="toast_message_collaborator">
                  <Icon
                    iconName="Completed"
                    className="icon_toast_collaborator"
                  />
                  {t("Se registro las ventas exitosamente")}
                </div>
                <Icon iconName="Clear" onClick={() => setToastExit(false)} />
              </div>
            )}
            <div className="collaborator_create_hader_buton">
              <Button
                onClick={() => setViewCreate(1)}
                className="collaborator_create_bt"
              >
                <Icon
                  iconName="add"
                  className="collaborator_create_icon"
                />
                <p> {t("Nuevo")}</p>
              </Button>
            </div>
            <DetailsListView
              refresh={refresh}
              keyList={"colaboradores"}
              onClickCardMode={() => {}}
              onClickGridMode={() => {}}
              mode={GRID_MODE}
              title={t("Ventas")}
              cols={columns}
              isGridList={true}
              listFilters={[]}
              quickFilters={listLevelsFilters}
              baseUrl={baseUrl}
              changeBlockUI={props.changeBlockUI}
              courier={props.courier}
            ></DetailsListView>
          </div>
        ) : (
            <SaleDetailView
              companies={listComaniesComplete}
              system={props.system}
              user={props.user}
              setviewcreate={setViewCreate}
              setToastExit={setToastExit}
              changeBlockUI={props.changeBlockUI}
            />
        )}
      </>
    );
}
